import '../styles/index.scss';
import dietGrid from './diet-grid';
import kcalPicker from './kcal-picker';
import navbar from './navbar';
import pricingPage from './pricing-page';

class Main {
    constructor() {
        this.onDOMLoaded();
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", () => {
            navbar.init();
            dietGrid.init();
            kcalPicker.init();
            pricingPage.init();
        });
    }
}

new Main();
